import { render, staticRenderFns } from "./metals.vue?vue&type=template&id=743dfb78&"
import script from "./metals.vue?vue&type=script&lang=js&"
export * from "./metals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports